// Design tokens y estilos compartidos por el rediseño de la Home (mobile y desktop).

export const homeColors = {
  pink: '#DA0067',
  pinkDark: '#B5004F',
  pink50: '#FDE7EF',
  pink100: '#FBD3E1',
  pinkSoft: '#FCEAF1',
  ink: '#1F1B1D',
  ink2: '#4A4448',
  ink3: '#7A7176',
  line: '#E9E4E6',
  bg: '#FAF8F7',
  bg2: '#F2EFEE',
  bg3: '#F5F5F5',
  white: '#FFFFFF',
  yellow: '#FFD84D',
};

export const homeEase = 'cubic-bezier(.22,.61,.36,1)';

// Inter y Poppins se cargan desde public/index.html. titleFont va en títulos y números
// destacados; el resto usa bodyFont. El !important pisa el `*` de headerStyle.css.
export const titleFont = "'Poppins', sans-serif !important";
export const bodyFont = "'Inter', 'Open Sans', sans-serif !important";

export const shadowSoft = '0 1px 0 rgba(31,27,29,0.02), 0 12px 28px -16px rgba(31,27,29,0.10)';
export const shadowPop = '0 1px 0 rgba(31,27,29,0.02), 0 20px 40px -16px rgba(218,0,103,0.20)';
export const cardShadow = '0 1px 0 rgba(31,27,29,0.02), 0 10px 22px -16px rgba(31,27,29,0.16)';
export const cardShadowHover = '0 1px 0 rgba(31,27,29,0.02), 0 14px 24px -14px rgba(218,0,103,0.20)';
// Tarjetas sobre fondo blanco: necesitan sombra en los cuatro lados (incluida la superior)
// para despegarse del fondo. La primera capa es la sombra hacia arriba.
export const shadowSoftStrong = '0 -8px 20px -10px rgba(31,27,29,0.16), 0 1px 0 rgba(31,27,29,0.04),'
  + ' 0 6px 14px -8px rgba(31,27,29,0.14), 0 22px 44px -18px rgba(31,27,29,0.26)';

export const HOME_MAX_WIDTH = 1180;

// Radio único de las tarjetas de la Home (simulador, propósito, stats, productos, requisitos).
export const CARD_RADIUS = '20px';

// Grilla de "Quiénes somos" en desktop: la tarjeta de propósito mide 400px y cada métrica 226.66px
// (proporciones del diseño), y todas comparten una altura de 340px.
export const ABOUT_GRID_COLUMNS = '400fr repeat(3, 226.66fr)';
export const STAT_CARD_HEIGHT = 340;

// Alto de las tarjetas de producto en desktop (el diseño las muestra bastante más altas
// que lo que ocupa su contenido).
export const PRODUCT_CARD_HEIGHT = 220;

// Alto de las tarjetas de requisitos en desktop (ícono arriba y texto centrado debajo).
export const REQUIREMENT_CARD_HEIGHT = 190;
export const REQUIREMENT_CARD_HEIGHT_MOBILE = 136;

// El header del sitio es fixed, así que la primera sección necesita dejarle lugar.
export const HEADER_MOBILE_HEIGHT = 50;

// Padding estándar de sección. En desktop se ensancha y se centra con HOME_MAX_WIDTH.
export const sectionPadding = (isMobile) => (isMobile ? '44px 20px' : '72px 24px');

export const sectionContentSx = {
  maxWidth: HOME_MAX_WIDTH,
  margin: '0 auto',
  width: '100%',
};

// Chip/píldora que abre cada sección, con el mismo formato que el del hero de Ayuda.
export const eyebrowSx = {
  display: 'inline-flex',
  alignItems: 'center',
  fontFamily: bodyFont,
  fontWeight: 700,
  fontSize: 12,
  lineHeight: 1,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: homeColors.pink,
  backgroundColor: homeColors.pink50,
  padding: '10px 18px',
  borderRadius: '999px',
};

export const sectionTitleSx = {
  fontFamily: titleFont,
  fontWeight: 700,
  letterSpacing: '-0.02em',
  lineHeight: 1.1,
  color: homeColors.ink,
};

export const bodyTextSx = {
  fontFamily: bodyFont,
  fontSize: 15,
  lineHeight: 1.5,
  color: homeColors.ink2,
};

export const smallTextSx = {
  fontFamily: bodyFont,
  fontSize: 13,
  lineHeight: 1.5,
  color: homeColors.ink3,
};

// CTA principal (píldora magenta). Se usa sobre Button de MUI con component="a".
export const ctaSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  height: 50,
  padding: '0 28px',
  backgroundColor: homeColors.pink,
  color: homeColors.white,
  border: 'none',
  borderRadius: '12px',
  fontFamily: titleFont,
  fontWeight: 600,
  fontSize: 16,
  letterSpacing: '-0.01em',
  textTransform: 'none',
  textDecoration: 'none',
  boxShadow: shadowPop,
  transition: `transform .25s ${homeEase}, box-shadow .25s ${homeEase}, background-color .2s ${homeEase}`,
  '&:hover': { backgroundColor: homeColors.pinkDark },
  '&:active': { transform: 'scale(0.98)' },
};

// CTA secundario: mismo tipo de píldora que ctaSx pero con borde y fondo transparente.
export const ctaOutlineSx = {
  ...ctaSx,
  height: 46,
  padding: '0 22px',
  fontSize: 15,
  backgroundColor: 'transparent',
  color: homeColors.pink,
  border: `1.5px solid ${homeColors.pink}`,
  boxShadow: 'none',
  '&:hover': { backgroundColor: homeColors.pink50 },
  '&:active': { transform: 'scale(0.98)' },
};
